function isNumber(value: any) {
  return typeof value === "number" && value + 0 === value
}
function getDecimalLength(num: number) {
  const decimalPart = (num + "")?.split(".")?.[1]
  return decimalPart ? decimalPart.length : 0
}
function validateSafe(num: number) {
  return num < Number.MAX_SAFE_INTEGER && num > Number.MIN_SAFE_INTEGER
}
export const FloatMath = {
  add(a: number, b: number) {
    try {
      if (!isNumber(a) || !isNumber(b))
        throw new Error("The entered number is not Number. ")
      if (!validateSafe(a))
        throw new Error("The entered number is outside the safe range. " + a)

      if (!validateSafe(b))
        throw new Error("The entered number is outside the safe range. " + b)
      const m = Math.max(
        (a + "")?.split(".")[1]?.length || 0,
        (b + "")?.split(".")[1]?.length || 0
      )
      const p = Math.pow(10, m)
      const ans = (a * p + b * p) / p
      if (!validateSafe(ans))
        throw new Error("The result number is outside the safe range. " + ans)
      return ans
    } catch (e) {
      throw new Error("[add] " + e?.message)
    }
  },
  subtract(a: number, b: number) {
    try {
      if (!isNumber(a) || !isNumber(b))
        throw new Error("The entered number is not Number. ")
      if (!validateSafe(a))
        throw new Error("The entered number is outside the safe range. " + a)

      if (!validateSafe(b))
        throw new Error("The entered number is outside the safe range. " + b)
      const r1 = getDecimalLength(a)
      const r2 = getDecimalLength(b)
      const p = Math.pow(10, Math.max(r1, r2))
      const result = (a * p - b * p) / p
      const ans = Number(result.toFixed(Math.max(r1, r2)))
      if (!validateSafe(ans))
        throw new Error("The result number is outside the safe range. " + ans)
      return ans
    } catch (e) {
      throw new Error("[subtract] " + e?.message)
    }
  },
  multiply(n: number, multiplier: number) {
    try {
      if (!isNumber(n) || !isNumber(multiplier))
        throw new Error("The entered number is not Number. ")
      if (!validateSafe(n))
        throw new Error("The entered number is outside the safe range. " + n)

      if (!validateSafe(multiplier))
        throw new Error(
          "The entered number is outside the safe range. " + multiplier
        )
      const r1 = getDecimalLength(n)
      const r2 = getDecimalLength(multiplier)
      const decimalLengthTotal = r1 + r2
      const ans =
        (Number((n + "").replace(".", "")) *
          Number((multiplier + "").replace(".", ""))) /
        Math.pow(10, decimalLengthTotal)
      if (!validateSafe(ans))
        throw new Error("The result number is outside the safe range. " + ans)
      return ans
    } catch (e) {
      throw new Error("[multiply] " + e?.message)
    }
  },
  divide(n: number, divisor: number) {
    try {
      if (!isNumber(n) || !isNumber(divisor))
        throw new Error("The entered number is not Number. ")
      if (!validateSafe(n))
        throw new Error("The entered number is outside the safe range. " + n)

      if (!validateSafe(divisor))
        throw new Error(
          "The entered number is outside the safe range. " + divisor
        )
      const r1 = getDecimalLength(n)
      const r2 = getDecimalLength(divisor)
      const numerator = Number(n.toString().replace(".", ""))
      const denominator = Number(divisor.toString().replace(".", ""))
      const ans = (numerator / denominator) * Math.pow(10, r2 - r1)
      if (!validateSafe(ans))
        throw new Error("The result number is outside the safe range. " + ans)
      return ans
    } catch (e) {
      throw new Error("[divide] " + e?.message)
    }
  },
}
